import { useLocalization } from '@magicdoor/ui';
import { Dynamic } from 'solid-js/web';
import { AuthPageContainer } from '~/components/auth/AuthPageContainer';
import { MagicLinkSignInView } from '~/components/auth/sign-in/MagicLinkSignIn';
import { OtpSignInView } from '~/components/auth/sign-in/OtpSignIn';
import { PasswordSignIn } from '~/components/auth/sign-in/PasswordSignIn';
import { RestLoginType } from '~/components/auth/sign-in/RestLoginType';
import { useAuth } from '~/contexts/global';
import { LoginType } from '~/utils/constant';
import type { Component } from 'solid-js';

const SignInPage = () => {
  const { t } = useLocalization();

  const { loginType } = useAuth();

  const loginComponentMap: Record<LoginType, Component> = {
    [LoginType.Password]: PasswordSignIn,
    [LoginType.MagicLink]: MagicLinkSignInView,
    [LoginType.Otp]: OtpSignInView,
  };

  return (
    <AuthPageContainer>
      <Dynamic component={loginComponentMap[loginType()]} />
      <div class="my-4 flex items-center justify-center text-xs text-text-level03">{t('Or')}</div>
      <RestLoginType />
    </AuthPageContainer>
  );
};

export default SignInPage;
